import { useRouter } from "next/navigation";
import useKeypress from "react-use-keypress";
import { RecordItem } from "types/common";
import type { ImageProps } from "../utils/types";
import useLastViewedPhoto from "../utils/useLastViewedPhoto";
import SharedModal from "./SharedModal";

export default function Carousel({ index, currentPhoto }: { index: number; currentPhoto: ImageProps & RecordItem }) {
  const [, setLastViewedPhoto] = useLastViewedPhoto();
  const router = useRouter();

  function closeModal() {
    setLastViewedPhoto(currentPhoto.recordId as any);
    router.replace("/gallery");
  }

  function changePhotoId(newVal: number) {
    return newVal;
  }

  useKeypress("Escape", () => {
    closeModal();
  });

  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <div className="absolute inset-0 z-30 cursor-default bg-black backdrop-blur-2xl" onClick={closeModal}></div>
      <SharedModal
        index={index}
        changePhotoId={changePhotoId}
        currentPhoto={currentPhoto}
        closeModal={closeModal}
        navigation={false}
      />
    </div>
  );
}
